import { render } from "./Starred.vue?vue&type=template&id=2bd40f16"
import script from "./Starred.vue?vue&type=script&lang=js"
export * from "./Starred.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__